/* @flow */

import { type Entregadores } from '../../entregadores/types';

const viewSelectEntregadores = (entregadores: Entregadores[]) => (
    entregadores.length > 0 ? `
    <label for="entregador-atendimento" style="min-width: 300px">
        Entregador(a)
        <input
            type="text"
            list="entregadores"
            class="form-control m-input"
            name="entregador"
            id="entregador-atendimento"
            placeholder="Exemplo: João"
        >
        <datalist id="entregadores">
            ${entregadores.map(entregador => `
                <option value="${entregador.nome}">
            `).join('')}
        </datalist>
    </label>
    ` : ''
);

export default viewSelectEntregadores;
